/**
 * Scheduling Module Query Keys
 *
 * Hierarchical query key factory for schedule rules and occurrences.
 * All keys include tenantId for proper multi-tenant cache scoping.
 */

export const SCHEDULE_RULE_ENTITY_KEY = 'schedule-rule';
export const SCHEDULE_RULE_LIST_KEY = 'schedule-rules';
export const SCHEDULE_OCCURRENCE_ENTITY_KEY = 'schedule-occurrence';
export const SCHEDULE_OCCURRENCE_LIST_KEY = 'schedule-occurrences';

export const scheduleRuleKeys = {
  all: [SCHEDULE_RULE_LIST_KEY] as const,

  lists: (tenantId: string) =>
    [...scheduleRuleKeys.all, 'list', tenantId] as const,

  list: (tenantId: string, filters: Record<string, unknown> = {}) =>
    [...scheduleRuleKeys.lists(tenantId), filters] as const,

  detail: (id: string, tenantId: string) =>
    [SCHEDULE_RULE_ENTITY_KEY, id, tenantId] as const,
};

export const scheduleOccurrenceKeys = {
  all: [SCHEDULE_OCCURRENCE_LIST_KEY] as const,

  lists: (tenantId: string) =>
    [...scheduleOccurrenceKeys.all, 'list', tenantId] as const,

  list: (tenantId: string, filters: Record<string, unknown> = {}) =>
    [...scheduleOccurrenceKeys.lists(tenantId), filters] as const,

  detail: (id: string, tenantId: string) =>
    [SCHEDULE_OCCURRENCE_ENTITY_KEY, id, tenantId] as const,
};
